import React from "react";
import {
  FaShieldAlt,
  FaUserFriends,
  FaCoins,
  FaExchangeAlt,
  FaMobileAlt,
  FaRedoAlt,
} from "react-icons/fa";

function FeaturesWallet() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-6">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Features & Wallet Development Service
                </h2>
              </div>
              <div className="col-lg-5 offset-lg-1">
                <p>
                  These features of Ethereum wallet securely manage Ethereum and
                  its diverse ecosystem of tokens and dApps.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaShieldAlt size={35} />
                  </div>
                  <h4>Secure Storage</h4>
                  <p>
                    Utilizes advanced encryption and private key management to
                    ensure the safety of users' Ether (ETH) and ERC-20 tokens.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaUserFriends size={35} />
                  </div>
                  <h4>User-Friendly Interface</h4>
                  <p>
                    Intuitive design that allows users to easily navigate, send,
                    and receive ETH and tokens without technical expertise.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaCoins size={35} />
                  </div>
                  <h4>Multi-Token Support</h4>
                  <p>
                    Ability to store and manage a variety of Ethereum-based
                    tokens (ERC-20, ERC-721, etc.) alongside Ether, providing
                    flexibility in asset management.
                  </p>
                  <br />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaExchangeAlt size={35} />
                  </div>
                  <h4>Seamless Transactions</h4>
                  <p>
                    Quick and efficient transaction processing with low gas
                    fees, enabling users to send and receive funds easily.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaMobileAlt size={35} />
                  </div>
                  <h4>Multi-Device Access</h4>
                  <p>
                    Synchronization across multiple devices, enabling users to
                    manage their wallets on smartphones, tablets, and desktops.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaRedoAlt size={35} />
                  </div>
                  <h4>Backup and Recovery Options</h4>
                  <p>
                    Secure backup solutions, such as mnemonic phrases or seed
                    phrases, to restore wallet access in case of device loss.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeaturesWallet;
